import { HelpHomeTemplateAdapter as HelpHomeTemplate } from "./HelpHomeTemplate";

export { HelpHomeTemplate };
export type { HelpHomeTemplateProps, HelpHomeTemplateContent } from "./HelpHomeTemplate.d";
